import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { BlogDetailArticle } from "../../components/blog";
import "./blog-detail.css";
import { BaseUrl } from '../../helper/BaseUrl';

export default function BlogDetail({ initialData }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const initialBlog = initialData?.detailpage || {};
  const initialRecentBlogs = Array.isArray(initialData?.listpage)
    ? initialData.listpage.slice(-3)
    : [];
  const [blogData, setBlogData] = useState(initialBlog);
  const [recentData, setRecentData] = useState(initialRecentBlogs);
  const fetchRecent = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blogs`, {
        method: "GET",
      });
      const result = await response.json();
      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      const blogs = Array.isArray(result.blogs) ? result.blogs : [];
      const currentBlog = blogs.find((item) => item.slug === slug);
      if (!currentBlog) {
        navigate("/404", { replace: true });
        return;
      }
      setBlogData(currentBlog);
      const latestBlogs = blogs.slice(-3);
      setRecentData(latestBlogs);
    } catch (error) {
      console.error("Fetch error:", error.message);
      navigate("/404", { replace: true });
    }
  };
  useEffect(() => {
    fetchRecent();
  }, [slug]);

  if (!Object.keys(blogData).length && !recentData.length) {
    return null;
  }
  return (
    <main className="blog-detail-page">
      <BlogDetailArticle initialData={initialBlog} data={recentData} />
    </main>
  );
}
